module.exports = __webpack_public_path__ + "static/media/advantage5.36606bd3.png";